<template>
  <CContainer>
    <CRow>


      <!-- Esta seccion debe implementarse y dejarse correcta con base en los presupuestos y siempre y cuando la Dependencia tenga activo ese parametro -->
      <!-- <CCol sm="6" lg="3">
        <CWidgetDropdown
          text="Presupuesto mensual"
          color="info"
          class="col-sm-12">
          <template #footer>
                <CChartPie
                  style="height:70px"
                  class="mt-3 pt-1 pb-1"
                  :datasets="[
                    {
                      data: [
                          80,
                          5,
                          15
                      ],
                      backgroundColor: [
                          '#3f51b5',
                          '#ced2d8',
                          '#804acd'
                      ],
                      label: 'Sales',
                    }
                  ]"
                  :labels="['Ejecutado', 'Disponible', 'Reservado']"
                  :options="{ 
                    maintainAspectRatio: false, responsive: true,
                    legend: {
                      display: false
                    }
                  }"
                />
          </template>
        </CWidgetDropdown>
      </CCol> -->


      <!-- <CCol sm="6" lg="3">
        <CWidgetDropdown
          text="Consumos mensuales"
          color="danger">
          <template #footer>
            <CChartBar
            style="height:70px"
              class="mt-3 mx-3"
              :labels="items.map(item => item.Periodo)"
              :datasets="[
                {
                  data: items.map(item => item.Valor_Mercancia),
                  backgroundColor: 'rgba(255,255,255,.2)',
                  borderColor: 'rgba(255,255,255,.55)',
                  barPercentage: 0.6
                }
              ]"
              :options="{
                  maintainAspectRatio: false, responsive: true,
                  legend: {
                    display: false
                  },
                  scales: {
                    xAxes: [{
                      display: false
                    }],
                    yAxes: [{
                      display: false
                    }]
                  }
              }"/>
          </template>
        </CWidgetDropdown>
      </CCol> -->
    </CRow>            
    <CRow>
      <CCol sm="12">
        <CCard>
          <CCardHeader>
            <span>Datos Empresa</span>
          </CCardHeader>
          <CCardBody>
            <CRow>
                <CCol sm="6">
                  <CRow class="mb-2"> 
                    <span class="text-muted col-sm-12"><strong>Empresa: </strong></span>
                    <span class="col-sm-12">{{$store.state.user.data.empresa}}</span>
                  </CRow>
                </CCol>
                <CCol sm="6">
                  <CRow class="mb-2"> 
                    <span class="text-muted col-sm-12"><strong>Estado:</strong></span>
                    <span class="col-sm-12"> </span>
                  </CRow>
                </CCol>
                <CCol sm="6">
                  <CRow class="mb-2">                      
                    <CSelect 
                      class="col-sm-12"
                      addLabelClasses="text-muted font-weight-bold" 
                      label="Dependencia / CenCos: " 
                      :options="dependencies.map(item => { return { value: item.id_Dependencia, label: item.dependencia } })"
                      :value.sync="selectedDependency"
                      @change="onChange($event)"
                      invalidFeedback="La Dependencia no ha sido asignada"/>
                  </CRow> 
                </CCol>
                <CCol sm="6">
                  <CRow class="mb-2">
                    <span class="text-muted col-sm-12"><strong>Responsable: </strong></span>
                    <span class="col-sm-12 mt-3">{{ dependency.responsable }}</span>
                    <span class="col-sm-12 mt-1">
                      Vr. Presupuesto $ 
                      <span class="font-weight-bold">{{ formatter.format($store.state.user.dependency.valorPresupuesto) }}</span>
                    </span>
                  </CRow>
                </CCol>
            </CRow>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
    <CRow class="mt-1">
      <CCol sm="4" class="text-center mb-2">
        <CLink 
          color="primary" 
          class="p-2 mx-auto d-block btn btn-dark py-5"
          to="/cliente/movimientos/pedidos">
          <CIcon name="cil-basket" size="xl" class="mx-auto d-block"/>
          <span class="d-block">Haga su pedido</span>
        </CLink>
      </CCol>
      <CCol sm="4" class="text-center mb-2">
        <CLink 
          color="primary" 
          class="p-2 mx-auto d-block btn btn-dark py-5"
          to="/cliente/archivo/productos">
          <CIcon name="cil-list-rich" size="xl"  class="mx-auto d-block"/>
          <span class="d-block">Listado de productos</span>
        </CLink>
      </CCol>


        <!-- Se debe implementar este modulo -->
        <!-- <CCol sm="4" class="text-center mb-2">
          <CLink 
            color="primary" 
            class="p-2 w-50 mx-auto d-block btn btn-dark py-5"
            to="/cliente/">
            <CIcon name="cil-notes" size="xl"  class="mx-auto d-block"/>
            <span class="d-block">Último pedido</span>
          </CLink>
        </CCol> -->

        
    </CRow>
    <CElementCover  v-show="loading"/>
  </CContainer>
</template>

<script>
  import moment from 'moment'
  import {formatter} from '../general'
  import { obtenerDependencia, dataGraficoVentasMensualesCliente } from '../api'
  import { dataListDependenciasUsuario } from '../apiDataList'

  export default {
    name: "HomeCustomer",
    data(){
      return {
        formatter,
        loading: false,
        items: [],
        dependencies: [],
        selectedDependency: ''
      }
    },
    async mounted(){
      await this.getDependencies()
      await this.getData()
      this.selectedDependency = this.$store.state.user.dependency.id_Dependencia

      await this.getDependency(this.selectedDependency)

      console.log(this.$store.state.user.dependency);
      console.log(this.$store.state.user.data.tipo_Gestor);
      console.warn(this.$store.state.user.dependency.valorPresupuesto)
    },
    methods: {
      async onChange(){
        console.info("ID Dependencia Seleccionado", this.selectedDependency)

        // Aqui se debe cargar los datos de compra de la dependencia como fechas de compra y el valor del presupuesto
        this.getDependency(this.selectedDependency)
        // await this.getDependency(this.selectedDependency)

        // const dependency2save = this.dependencies.find(dependency => dependency.id_Dependencia == this.selectedDependency)

        // console.log(dependency2save);

        // if (dependency2save) {
        //   this.$store.commit('setDependency', dependency2save)
        // } else {
        //   this.$store.commit('setDependency', {
        //     responsable: '',
        //     dependencia: '',
        //     id_Dependencia: ''
        //   })
        // }

        console.warn("Valor Presupuesto ", this.$store.state.user.dependency.valorPresupuesto)

        await this.getData()
      },
      async getDependencies(){        
        try {
          const response = await dataListDependenciasUsuario (
            this,
            this.$store.state.user.data.id_Usuario
          )
          this.dependencies = [{ id_Dependencia: '', dependencia: "Seleccionar" }, ...response]
        } catch (error) {
          error
        }
      },
      async getDependency(idDependecy) {
        console.info("Entro al method getDependency")
        let dependency2save = {
          responsable: '',
          dependencia: '',
          activadoPresupuesto: '',
          valorPresupuesto: 0,
          id_Dependencia: ''
        }

        if (idDependecy) {
          try {
            const response = await obtenerDependencia(this, idDependecy)
            dependency2save = {
              responsable: response.responsable,
              dependencia: response.dependencia,
              activadoPresupuesto: response.activar_Presupuesto,
              valorPresupuesto: response.valor_Presupuesto,
              id_Dependencia: response.id_Dependencia
            }
            this.$store.commit('setDependency', dependency2save)
            console.info("se cargaron y grabaron en el store los datos de la dependencia...")
          } catch (error) {
            this.$store.commit('setDependency', dependency2save) 
            console.log(error);
          }
        } else {
          this.$store.commit('setDependency', dependency2save) 
        }

        console.warn(dependency2save)
      },
      async getData() {
        try {
          this.loading = true

          const sValue = typeof(this.selectedDependency) === "object" ? this.selectedDependency.value : this.selectedDependency
          const { response } = await dataGraficoVentasMensualesCliente(
            this,
            this.$store.state.user.data.id_Directorio,
            moment().subtract(1, 'year').startOf('month').format('YYYY-MM-DD'),
            moment().format('YYYY-MM-DD'),
            sValue.length == 0 ? null : sValue
          )

          this.items = response
        } catch (error) {
          this.$store.commit('setAlert', {
            color: "danger",
            message: 'Error al cargar datos',
            show: 5
          })
        } finally {
          this.loading = false
        }
      }
    },
    computed:{
      dependency() {
        return this.$store.state.user.dependency
      }
    }
}
</script>